import tree from './assets/landscape/tree-left.svg?raw';
import pavilion from './assets/landscape/pavilion-right.svg?raw';
import './gameCard.css';

/** Reuse cropped landscape artwork instead of maintaining duplicate card assets. */
function crop(svg: string, viewBox: string) {
  return `data:image/svg+xml,${encodeURIComponent(svg.replace(/<svg[^>]*>/, (root) => root.replace(/ (?:width|height)="[^"]*"/g, '')).replace(/viewBox="[^"]+"/, `viewBox="${viewBox}"`))}`;
}
export const gameCard = {
  left: crop(tree, '940 40 800 900'),
  right: crop(pavilion, '2350 280 450 430'),
};
